import React from 'react';

import { observer } from 'mobx-react';
import { IconButton, Switch } from '@infoods/lifebase-ui';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';

import classes from './RecipeRowActions.module.scss';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { SeparatorLine } from '../../../../../shared/components/ui-components';
import { openConfirmationModal } from '../../../../../shared/features/confirmation';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { RecipeListItem } from '../../../../interfaces/RecipeListItem';
import { recipesListStore } from '../../../../stores/recipesListStore';

type RecipeRowActionsProps = {
  recipe: RecipeListItem;
  /** Edit page for own recipes, add page (clone) for the rest — shared with the row's name cell */
  editHref: string;
};

const RecipeRowActions = observer(({ recipe, editHref }: RecipeRowActionsProps) => {
  const { id, banned, editable } = recipe;
  const { isSuperAdmin } = loggedInUserDataStore;
  const { changeRecipeState, deleteRecipe } = recipesListStore;

  const handleBanToggle = () => {
    changeRecipeState(id, !banned);
  };

  const handleDeleteClick = () => {
    openConfirmationModal({
      title: 'Are you sure you want to delete recipe?',
      confirmBtnConfig: { onClick: () => deleteRecipe(id), text: 'Delete' },
    });
  };

  return (
    <GridTableCell className={classes.actionsCell}>
      {!isSuperAdmin && <Switch checked={!banned} onChange={handleBanToggle} />}
      <SeparatorLine />
      <IconButton
        href={editHref}
        color="secondary"
        data-test-id={editable ? 'edit-btn' : 'clone-btn'}
      >
        {editable ? (
          <ModeEditOutlinedIcon fontSize="medium" />
        ) : (
          <ContentCopyRoundedIcon fontSize="medium" />
        )}
      </IconButton>
      {editable && (
        <IconButton
          onClick={handleDeleteClick}
          color="secondary"
          data-test-id="delete-btn"
        >
          <DeleteOutlineRoundedIcon fontSize="medium" />
        </IconButton>
      )}
    </GridTableCell>
  );
});

export { RecipeRowActions };
